/**
 * KPI tiles side by side: two across on a phone (a dashboard of one tile per screen is a scroll,
 * not a glance), then three or four on wide screens. The kit's StatGrid drops to one column on a
 * phone, which suits a form's figures but not a row of KPIs.
 */
const COLUMNS = { 2: "", 3: "xl:grid-cols-3", 4: "xl:grid-cols-4" } as const;

export function TileGrid({ columns = 4, children }: { columns?: 2 | 3 | 4; children: React.ReactNode }) {
  return <div className={`motion-stagger grid grid-cols-2 gap-3 ${COLUMNS[columns]}`}>{children}</div>;
}
